import IActivity from '../../interfaces/IActivity';
import React from 'react';
import { Card, CardBody } from 'react-bootstrap';

interface ActivityReviewProps {
    activity: IActivity;
}

const toDL = (key: string, value?: any) => {
    return (
        <>
            <dt className={'col-5'}>{key}:</dt>
            <dd className={'col-7'}>{value ?? '-'}</dd>
        </>
    );
};

const ActivityReviewEntry: React.FC<ActivityReviewProps> = ({ activity }) => {
    return (
        <Card className={'bg-light-subtle border-1 mb-2 p-0 rounded-top-4'}>
            <Card.Header>{activity.eventAndTitle}</Card.Header>
            <CardBody>
                <dl className={'row'}>
                    {toDL('Date', activity.date && new Date(activity.date).toLocaleDateString())}
                    {toDL('Related Credits/Hours', activity.relatedCreditsHours)}
                    {toDL('Specific EMDR Credits', activity.specificEmdrCredits)}
                    {toDL('Provider', activity.provider)}
                    {toDL('Speaker(s)', activity.speakers)}
                </dl>
            </CardBody>
        </Card>
    );
};

export default ActivityReviewEntry;
